import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Button,
  Chip
} from '@mui/material';
import DepartmentIcon from '@mui/icons-material/AccountBalance';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useNavigate } from 'react-router-dom';
import { useDepartment } from '../context/DepartmentContext';

const DepartmentHeader = ({ returnPath }) => {
  const { selectedDepartment } = useDepartment();
  const navigate = useNavigate();

  const handleChangeDepartment = () => {
    // Navigate to the selector page with the return path
    navigate(`/select-department?return=${returnPath || window.location.pathname}`);
  };

  if (!selectedDepartment) return null;

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        mb: 3, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        backgroundColor: 'primary.light',
        color: 'primary.contrastText',
        borderRadius: 1
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DepartmentIcon sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight="bold">
          Department: {selectedDepartment.department_name}
        </Typography>
        <Chip 
          label={selectedDepartment.department_code} 
          size="small" 
          sx={{ ml: 1, backgroundColor: 'rgba(255,255,255,0.2)' }} 
        />
      </Box>
      <Button 
        startIcon={<SwapHorizIcon />} 
        variant="outlined" 
        size="small"
        onClick={handleChangeDepartment}
        sx={{ 
          color: 'primary.contrastText', 
          borderColor: 'primary.contrastText',
          '&:hover': {
            borderColor: 'primary.contrastText',
            backgroundColor: 'rgba(255,255,255,0.1)'
          }
        }}
      >
        Change Department
      </Button>
    </Paper>
  );
};

export default DepartmentHeader;
